
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-slate-900 mb-4" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              会社概要
            </h2>
            <div className="flex items-center justify-center gap-2">
              <div className="w-12 h-0.5 bg-amber-500"></div>
              <div className="w-2 h-2 bg-amber-500 rotate-45"></div>
              <div className="w-12 h-0.5 bg-amber-500"></div>
            </div>
          </div>

          <div className="bg-white shadow-xl border-l-4 border-amber-500">
            <table className="w-full" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              <tbody>
                <tr className="border-b border-gray-200">
                  <th className="bg-slate-50 px-8 py-5 text-left font-bold text-slate-700 w-1/3">
                    会社名
                  </th>
                  <td className="px-8 py-5 text-slate-800">
                    株式会社eta
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <th className="bg-slate-50 px-8 py-5 text-left font-bold text-slate-700">
                    所在地
                  </th>
                  <td className="px-8 py-5 text-slate-800">
                    静岡県伊東市富戸877番地の4
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <th className="bg-slate-50 px-8 py-5 text-left font-bold text-slate-700">
                    設立
                  </th>
                  <td className="px-8 py-5 text-slate-800">
                    2016年05月10日
                  </td>
                </tr>
                <tr>
                  <th className="bg-slate-50 px-8 py-5 text-left font-bold text-slate-700">
                    代表者
                  </th>
                  <td className="px-8 py-5 text-slate-800">
                    代表取締役　二宮　妃時
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-12 bg-gradient-to-br from-slate-900 to-slate-800 shadow-xl p-10">
            <h3 className="text-2xl font-bold text-white mb-6" style={{ fontFamily: '"Noto Serif JP", serif' }}>
              事業の特徴
            </h3>
            <ul className="space-y-4 text-gray-200" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                <span>ネット完結型で全国対応可能</span>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                <span>個人事業者・小規模事業者を対象とした利用料・手数料収益モデル</span>
              </li>
              <li className="flex items-start gap-4">
                <div className="w-2 h-2 bg-amber-500 mt-2 flex-shrink-0"></div>
                <span>本店事務所にPC・ネット環境を整備済み</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
